/**
 * debounce function
 * @param func - function to be debounced
 * @param delay - delay in milliseconds
 */
export function debounce(func, delay) {
    let debounceTimer;
    return function (...args) {
        clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(() => func.apply(this, args), delay);
    };
}
//# sourceMappingURL=debounce.js.map